import { render, staticRenderFns } from "./JudgmentDiligenceRequestModal.vue?vue&type=template&id=c2d49b40&"
import script from "./JudgmentDiligenceRequestModal.vue?vue&type=script&lang=js&"
export * from "./JudgmentDiligenceRequestModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports